import React from 'react';


import {  Row, Col } from 'react-bootstrap';

import Button from 'src/components/button';
import styles from './DeleteContactListView.module.scss';
import ContactListRow from './components/ContactListRow.jsx'
import { localizedStrings } from 'src/localization';
class DeleteContactListView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
    this.localizedDeleteSlider = this.localizedDistributionList.sliders.add_contacts.delete_slider;
  }

  _handleDeleteClick() {
    var index = this.props.contactLists.findIndex((contactList) => {
      return contactList.id == this.props.contactList.id;
    })

    this.props.deleteContactList(this.props.contactList.id).then(() => {
      if (this.props.onDeletion) {
        this.props.onDeletion();
      }

      var nextIndex = 0;

      if (index > 0) {
        var nextIndex = index++;

        if (nextIndex > this.props.contactLists.length - 1) {
          nextIndex = this.props.contactLists.length - 1;
        }
      }

      var nextContactList = this.props.contactLists[nextIndex];
      if (nextContactList) {
        this.props.navigate(`/settings/contact_list/${nextContactList.id}`);
      } else {
        this.props.navigate(`/settings/contact_list`);
      }
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <Col xl={12} lg={12} className={styles.column}>
            <div className={styles.heading}>{this.localizedDeleteSlider.title}</div>
            <div className={styles.label}>
              1 {this.localizedDeleteSlider.contact_list}
                </div>

            <p className={styles.description}>
              {this.localizedDeleteSlider.description}
                </p>
          </Col>
          <Col xl={12} lg={12}  className={styles.column}>
            <div className={styles.contacts}>
              {this.props.contactList &&
                <ContactListRow 
                  className={styles.contactList}
                  key={this.props.contactList.id} 
                  contactList={this.props.contactList} 
                  showBorders={false}
                />
              }
            </div>
          </Col>
        </Row>
        <div className={styles.buttonTray}>
        <Button 
          text={this.props.deleting ? `${this.localizedCommonActions.deleting}...` : this.localizedCommonActions.delete}
          disabled={this.props.deleting}
          variant='primary'
          onClick={() => { this._handleDeleteClick() }}
        />
        <Button
          text={this.localizedCommonActions.cancel}
          disabled={this.props.deleting}
          onClick={() => { this._handleCancelClick() }}
        />
        </div>
        
      </div>
    );
  }
}
export default DeleteContactListView;